module.exports = __webpack_public_path__ + "static/media/2.e30c85ca.jpeg";